import { faRemove } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next"; // Import translation hook

const DeleteSchoolModal = ({ show, handleClose, handleConfirmDelete, isPermanent = false }) => {
  const { t } = useTranslation(); // Initialize translation hook

  return (
    <Modal show={show} onHide={handleClose} centered size={"md"}>
      <Modal.Header className="border-0" closeButton></Modal.Header>
      <Modal.Body className="text-center">
        <FontAwesomeIcon
          className="p-3"
          icon={faRemove}
          style={{
            fontSize: "40px",
            color: "red",
            border: "3px solid red ",
            borderRadius: "60px",
            width: "40px",
            height: "40px",
          }}
        />
        <h3 className="mt-1">{t("Are You Sure")}</h3>{" "}
        {/* Translated "Are You Sure" */}
        <p className="text-muted">
          {isPermanent
            ? t(
                "Do you really want to permanently delete this record? This process cannot be undone and all data will be lost forever."
              )
            : t(
                "Do you really want to delete this record? This process cannot be undone."
              )}
        </p>{" "}
        {/* Translated text */}
      </Modal.Body>
      <Modal.Footer className="justify-content-between pt-0 border-0">
        <Button
          variant="secondary"
          type="submit"
          className="mt-1 px-4 py-2 border-0 button-style"
          style={{
            background: "linear-gradient(270deg, #272727 0%, #4B4B4B 100%)",
          }}
          onClick={handleClose}
        >
          {t("Back")} {/* Translated "Back" */}
        </Button>
        <Button
          variant="primary"
          type="submit"
          className="mt-1 px-4 py-2 border-0 button-style"
          onClick={handleConfirmDelete}
        >
          {isPermanent ? t("Yes, Permanently Delete") : t("Yes Delete")}{" "}
          {/* Translated "Yes Delete" */}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteSchoolModal;
